import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submit(), 200)
  }

  submit() {
    if (this.element.value.length < 2) return

    const form = this.element.form
    const frame = form.dataset.turboFrame && document.getElementById(form.dataset.turboFrame)
    if (frame?.tagName === "TURBO-FRAME") {
      // A new query starts a new list, so show it from the top once it renders.
      frame.addEventListener("turbo:frame-load", () => this.scrollToTop(frame), { once: true })
    }

    if (form.dataset.turboFrame === "search_results") {
      if (frame) frame.src = `/search?search[term]=${encodeURIComponent(this.element.value)}`
    } else {
      form.requestSubmit()
    }
  }

  // Results scroll inside their own overflow containers (sometimes nested), so
  // reset each one between the frame and the body. When the page itself
  // scrolls, the browser already brings the focused input back into view as
  // the user types.
  scrollToTop(frame) {
    for (let element = frame; element && element !== document.body; element = element.parentElement) {
      const { overflowY } = getComputedStyle(element)
      if (overflowY === "auto" || overflowY === "scroll") element.scrollTop = 0
    }
  }
}
